module.exports = __webpack_public_path__ + "static/media/success.9d6def6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/icons/success.svg
// module id = 878
// module chunks = 0